import type { Props } from '@studio/design-system/stepper';
import { Step, Stepper } from '@studio/design-system/stepper';
import type { ReactElement } from 'react';
import { Column, Exhibit } from './styled.jsx';

const Exemplar = (props: Omit<Props, 'children'>): ReactElement => (
  <Stepper {...props}>
    <Step icon='source' label='Select a source' />
    <Step icon='camera' label='Configure video' />
    <Step icon='joystick' label='Connect controls' />
  </Stepper>
);

/** `<Steppers>` exhibit. */
export const Steppers = (): ReactElement => (
  <Exhibit title='Steppers'>
    <Column className='w-[752px] bg-transparent'>
      <Exemplar />
      <Exemplar step={1} />
      <Exemplar step={2} />
      <Exemplar step={3} />
      <Exemplar step={4} />
    </Column>
  </Exhibit>
);
